module.exports = __webpack_public_path__ + "static/media/00_parachutez_card.26e232e0.png";